'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from 'react';

const POSTHOG_KEY = 'phc_rFH7yDjS0dSr0T1Me6HUh01uHqqmknMdT140QMZkSrr';

if (typeof window !== 'undefined') {
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://events.klonkaffe.dk',
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-05-30',
    person_profiles: 'always',
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
  });
  posthog.register({
    environment: window.location.hostname.includes('dev.') ? 'development' : 'production',
  });
}

function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      const search = searchParams.toString();
      if (search) url += `?${search}`;
      posthog.capture('$pageview', { $current_url: url });
    }
  }, [pathname, searchParams]);

  return null;
}

export default function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <PHProvider client={posthog}>
      <Suspense fallback={null}>
        <PostHogPageView />
      </Suspense>
      {children}
    </PHProvider>
  );
}
